import Alpine, { Alpine as AlpineInterface } from 'alpinejs';
import { ApiError, ApiSuccess, send } from '../../helpers/api';
import { FileInputResponse } from '../../../components/fields/types';
import { getGeoLocURL } from '../../../components/autocomplete/helpers';
import {
    JsonFormChoice,
    JsonFormType,
    MultipleCheckChoice,
    SimpleCheckChoice
} from "./types";
import { GetLocation } from '../../../components/autocomplete/types';
import { trybaPhoneMask, zipOrCityMask, isValidZipCityLocation } from '../../helpers/validation';
import { sendEventDataLayer, sendTunnelForm } from '../../alpine/include/taggage'
import {
    addQwamplifyToFormData,
    addUtmToFormData,
    autocompleteFromFieldName,
} from '../../helpers/form';
import { getUserData } from '../../../helpers/user'
import { activateAbTestByEvent } from '../../ab/registry';
import { AlpineComponentTryba } from '../../alpine/include/global';
import {
    formatPhoneForCrm,
    getPhonePrefixStore,
    isPhoneInputValid,
} from '../../tunnels/components/phonePrefixComponent';

const getVisibleInput = (name: string): HTMLInputElement | null => {
    const inputs = Array.from(document.querySelectorAll(`[name="${name}"]`)) as HTMLInputElement[];

    return inputs.find((input) => input.offsetParent !== null && input.getClientRects().length > 0) ?? null;
};

type AlpineTryba = Omit<AlpineInterface, 'data'> & {
    data(name: string, callback: (jsonForm: JsonFormType, myFormName: string, abTestType: any) => AlpineComponentTryba): void;
}

declare global {
    interface Window {
        AlpineTryba: AlpineTryba;
    }
}

enum FormName {
    FORM_QUOTATION = 'Demande de devis',
    FORM_APPOINTMENT = 'Demande de rendez-vous'
}

enum AbTestName {
    AB_TEST_CHOICE = 'choix-preliminaire',
    AB_TEST_VALIDATION = 'validation-checkmark',
}

window.AlpineTryba = Alpine as unknown as AlpineTryba;

document.addEventListener('alpine:init', () => {
    window.AlpineTryba.data('initQuotationsForm', (jsonForm: JsonFormType, myFormName: string, abTestType: AbTestName) => {
        // directly lazyLoad the images from the first step
        const allBackgrounds = [
            jsonForm?.steps?.init?.choices,
        ].flat().filter(item => item !== undefined) as JsonFormChoice[];
        if (allBackgrounds.length) {
            const backgroundToLazyLoad = allBackgrounds.map(choice => choice.data.background?.path);
            if (backgroundToLazyLoad !== undefined && backgroundToLazyLoad.length > 0) {
                backgroundToLazyLoad.forEach(b => {
                    if (b === undefined) return;
                    const img = new Image();
                    img.src = b;
                })
            }
        }
        return {
            ...{
                zipOrCityMask,
                trybaPhoneMask,
                ...sendTunnelForm,
            },
            ...{
                formName: myFormName,
                form: jsonForm,
                formData: new FormData(),
                isLaptop: false,
                isDesktop: false,
                sendUrl: jsonForm.action,
                steps: null,
                initStepKey: null,
                initStep: null,
                isInitStep: false,
                nextStepKey: '',
                step: null,
                historyContent: [],
                stepChoice: null,
                arrayChoice: {},
                stepBackground: null,
                prevSteps: [],
                stepChoiceKey: null,
                stepKey: null,
                choice: null,
                loading: false,
                displayChoices: false,
                displayFields: false,
                progressbar: null,
                totalSteps: 10,
                currentStep: null,
                activeChoice: false,
                dataChoice: {},
                errorMessage: null,
                successResponse: [],
                allInputs: [],
                nbInputs: null,
                stepNumber: null,
                mulptipleCheckItems: [],
                mulptipleCheckDatas: [],
                inputFileFormData: null,
                changeBtnType: false,
                minHeight: 0,
                loadingBtn: false,
                //AbTest
                fromAbTest: false,
                abTestName: '',
                skipAppointmentStep: false,
                ABMoveLocationWidth: false,
                ABMoveLocation: false,
                //Geoloc
                geolocLoading: false,
                lat: null,
                lng: null,
                zipCode: null,
                city: null,
                inputElement: null,
                disabled: true,
                initInputContent: getUserData(),
                //StoreCard
                enableStoreCard: false,
                storeDatas: [],
                storeMap: null,
                shopCode: null,
                shopCity: null,
                shopAdresse: null,
                shopName: null,
                shopCP: null,
                //Read More Recap
                moreContent: false,
                showBtn: false,
                totalContent: false,
                buttonsDisabled: {
                    projectLocalisation: true,
                    productsInterested: true,
                    personalInfos: true,
                },
                civilityValid: false,
                lastNameValid: false,
                firstNameValid: false,
                emailValid: false,
                telValid: false,
                addressValid: false,
                locationValid: false,
                //Abtest last step validations checkmarks
                enableCheckMark: false,
                isValidationGlobalRunned: false,
                //Abtest display reviews in recap
                displayReviews: false,
                //Abtest progress bar
                displayProgressSteps: false,
                progressStepsCustom: false,
                //Abtest progress bar appointment mobile
                displayMobileAppointmentProgressSteps: false,
                //Abtest progress bar quotation mobile
                displayMobileQuotationProgressSteps: false,
                // Textarea chars counter
                nbOfChars: 0,
                MaxNbOfChars: 1500,
                //ABtest progress bar quotation
                fakeSteps: [],
                // Chars max value
                maxCharsLastName: 150,
                maxCharsFirstName: 150,
                maxCharsEmail: 150,
                maxCharsAddress: 300,
                init() {
                    //Check if abTest running
                    const enumKeys = Object.keys(AbTestName);
                    for (const key of enumKeys) {
                        const enumValue = AbTestName[key as keyof typeof AbTestName];
                        if (typeof enumValue === 'string' && enumValue === abTestType) {
                            this.fromAbTest = true
                            this.abTestName = AbTestName[key as keyof typeof AbTestName]
                        }
                    }
                    //If abTest running and have to modify totalSteps
                    this.abTestName == AbTestName.AB_TEST_CHOICE && (this.totalSteps = 2)
                    this.isLaptop = window.matchMedia('(max-width: 1600px) and (min-width: 1400px)').matches;
                    this.isDesktop = window.matchMedia('(min-width: 1600px)').matches;
                    //Push init stepnumber
                    this.stepNumber = 0;
                    //ProgressBar
                    this.currentStep = 1;
                    this.progressBarWidth = '0%';
                    //Get all steps
                    this.steps = this.form.steps;
                    // START ABTEST DECLARATION
                    window.addEventListener("ab-init-quotation-multiple-choice", (e: any) => {
                        activateAbTestByEvent('ab-init-quotation-multiple-choice', e.detail);
                        this.runABtestInitForm(e.detail.ABTest)
                    });
                    window.addEventListener("ab-quotation-laststep-validation", () => {
                        activateAbTestByEvent('ab-quotation-laststep-validation');
                        if (this.formName == FormName.FORM_QUOTATION) {
                            this.runABtestLastStepValidation()
                        }
                    });
                    window.addEventListener("ab-recap-reviews", () => {
                        activateAbTestByEvent('ab-recap-reviews');
                        if (this.formName == FormName.FORM_APPOINTMENT) {
                            this.runABtestRecapReviews();
                        }
                    })
                    window.addEventListener("ab-appointment-delete-rdv-step", () => {
                        activateAbTestByEvent('ab-appointment-delete-rdv-step');
                        if (this.formName == FormName.FORM_APPOINTMENT) {
                            this.runABtestDeleteRdvStep()
                        }
                    });
                    window.addEventListener("ab-move-location", () => {
                        activateAbTestByEvent('ab-move-location');
                        this.runABtestMoveLocation(this.formName)
                        if (this.formName == FormName.FORM_APPOINTMENT) {
                            this.runInitForm('meetMethod')
                            if (this.prevSteps.length > 0) {
                                this.prevSteps.forEach((item: any) => {
                                    if (item.name === 'location') {
                                        this.prevSteps.splice(this.prevSteps.indexOf(item), 1)
                                    }
                                })
                            }
                            return;
                        }
                    });
                    window.addEventListener("ab-appointment-mobile-proressbar", () => {
                        activateAbTestByEvent('ab-appointment-mobile-proressbar');
                        if (this.$store.global.isMobile && this.formName == FormName.FORM_APPOINTMENT) {
                            this.runABtestAppointmentMobileProgressBar();
                        }
                    })
                    window.addEventListener("ab-quotation-progressbar", () => {
                        activateAbTestByEvent('ab-quotation-progressbar');
                        if (this.formName == FormName.FORM_QUOTATION) {
                            this.runAbTestQuotationProgressBar()
                        }
                    })
                    // END ABTEST DECLARATION

                    // Custom progress bar on appointment desktop
                    if (!this.$store.global.isMobile && (this.formName == FormName.FORM_APPOINTMENT)) {
                        this.appointmentDesktopProgressBar()
                    }

                    //Run basic init form
                    this.runInitForm()

                    // add padding to body
                    document.querySelector('body')?.classList.add('pt-16');

                    setTimeout(() => {
                        this.getProductUrlParams();
                    }, 300)
                },
                // Skip first step if product in url
                getProductUrlParams() {
                const params = new URLSearchParams(document.location.search);
                let product = params.get("product");
                if (product == 'pergolas') {
                    product = 'stores-solaires'
                }
                if (product != null) {
                    const choices = document.querySelectorAll('.js-choice');
                    choices.forEach((choice: any) => {
                        if (choice.getAttribute('choice') == product) {
                            choice.click();
                        }
                    })

                }
                },
                runInitForm(customInitStep: string) {
                    // START - Custom code form ab-move-location
                    if (customInitStep) {
                        this.initStepKey = customInitStep
                        this.initStep = this.steps[this.initStepKey];
                    } else {
                        this.initStepKey = this.form.initStep;
                        this.initStep = this.steps[this.initStepKey];
                    }
                    // END - Custom code form ab-move-location

                    // if history has step, push in step var, else get init step
                    if (history.state) {
                        const historyContent = JSON.parse(history.state);
                        this.step = historyContent[0];
                        this.arrayChoice = historyContent[1];
                        this.prevSteps = historyContent[2];
                        this.stepNumber = historyContent[3];
                        this.displayChoices = historyContent[4];
                        this.displayFields = historyContent[5];
                    } else {
                        this.step = this.initStep;
                        this.isInitStep = true;
                    }
                    //Get init step background
                    if (this.step.data.length != 0) {
                        this.stepBackground = this.step.data.background.path;
                    }
                    //Display choices
                    // this.displayChoices = true
                    if (this.step.choices.length != 0) {
                        this.displayChoices = true;
                    }
                    if (this.step.fields.length != 0) {
                        this.displayFields = true;
                    }
                    //Get recap init step wording and make read more on mobile
                    this.initStepWording = this.form.initStepWording;
                    setTimeout(() => {
                        //Run progressBar
                        this.makeProgress();

                        if (this.$refs.clamp && this.$store.global.isMobile) {
                            const content = this.$refs.clamp.offsetHeight;
                            if (content <= 96) {
                                this.moreContent = false;
                                this.showBtn = false;
                            } else {
                                this.moreContent = true;
                                this.showBtn = true;
                                this.totalContent = false;
                            }
                        }
                    }, 200);
                    this.shopCode = this.form.shopCode;
                    if (this.step.name === 'location' && this.initInputContent && this.initInputContent.localisation) {
                        this.arrayChoice[this.step.name] = this.dataChoice[this.step.name] = this.initInputContent.localisation.zip + ' ' + this.initInputContent.localisation.city;
                        this.handleClickField()
                    }
                    // Run send data layer function
                    this.sendDataLayer(this.formName, this.stepNumber, this.step.tag)

                    // Fix décallage progress bar
                    if (this.formName == FormName.FORM_APPOINTMENT) {
                        if (this.arrayChoice['location']) {
                            this.stepNumber = this.stepNumber + 1
                        } else {
                            this.stepNumber = 1
                        }
                    }
                },
                // START ABTEST SCRIPTS
                runABtestLastStepValidation() {
                    this.enableCheckMark = true
                },
                runABtestInitForm(key: string) {
                    this.initStep = this.steps['init' + key];
                    document.cookie = "QUOTATION_REMOVE_STEPS_AB=B; path=/";
                    // if history has step, push in step var, else get init step
                    if (history.state) {
                        const historyContent = JSON.parse(history.state);
                        this.step = historyContent[0];
                        this.arrayChoice = historyContent[1];
                        this.prevSteps = historyContent[2];
                        this.stepNumber = historyContent[3];
                        this.displayChoices = historyContent[4];
                        this.displayFields = historyContent[5];
                    } else {
                        this.step = this.initStep;
                        this.isInitStep = true;
                    }
                    //Get init step background
                    if (this.step.data.length != 0) {
                        this.stepBackground = this.step.data.background.path;
                    }
                    //Display choices
                    // this.displayChoices = true
                    if (this.step.choices.length != 0) {
                        this.displayChoices = true;
                    }
                    if (this.step.fields.length != 0) {
                        this.displayFields = true;
                    }
                    //Get recap init step wording and make read more on mobile
                    this.initStepWording = this.form.initStepWording;
                    setTimeout(() => {
                        //Run progressBar
                        this.makeProgress();

                        if (this.$refs.clamp && this.$store.global.isMobile) {
                            const content = this.$refs.clamp.offsetHeight;
                            if (content <= 96) {
                                this.moreContent = false;
                                this.showBtn = false;
                            } else {
                                this.moreContent = true;
                                this.showBtn = true;
                                this.totalContent = false;
                            }
                        }
                    }, 200);
                    this.shopCode = this.form.shopCode;
                    if (this.step.name === 'location' && this.initInputContent) {
                        this.arrayChoice[this.step.name] = Object.values(JSON.parse(this.initInputContent)[0])[0] + ' ' + Object.values(JSON.parse(this.initInputContent)[1])[0];
                        this.dataChoice[this.step.name] = Object.values(JSON.parse(this.initInputContent)[0])[0] + ' ' + Object.values(JSON.parse(this.initInputContent)[1])[0];
                        this.handleClickField()
                    }
                    // Run send data layer function
                    this.sendDataLayer(this.formName, this.stepNumber, this.step.tag)
                },
                runABtestRecapReviews() {
                    this.displayReviews = true;
                },
                runABtestDeleteRdvStep() {
                    this.skipAppointmentStep = true;
                    this.handleClick()
                },
                runABtestMoveLocation(formName: string) {
                    // window.dispatchEvent(new CustomEvent('ab-move-location'));
                    if (formName == FormName.FORM_QUOTATION) {
                        // On choices of project type, remove the location step from next step key and add coordinates
                        this.steps['project-type'].choices.forEach((item: any) => {
                            item.nextStep = 'coordinates'
                        })
                        // Add location field to coordinates
                        const locationObj = this.steps['location'].fields[0]
                        this.steps['coordinates'].fields.splice(4, 0, locationObj);
                        this.ABMoveLocationWidth = true
                    }
                    if (formName == FormName.FORM_APPOINTMENT) {
                        const locationObj = this.steps['location'].fields[0]
                        this.steps['coordinates'].fields.splice(5, 0, locationObj);
                        this.ABMoveLocation = true
                    }
                },
                runABtestAppointmentMobileProgressBar() {
                    // Hide base progress bar
                    document.querySelector('.progress-bar')?.classList.add('hidden');
                    // Display the progress steps
                    this.displayMobileAppointmentProgressSteps = true
                },
                runAbTestQuotationProgressBar() {
                    // Fake steps
                    this.fakeSteps = [
                        {
                            number: 1,
                            name: '1. Produits',
                            acceptedSteps: ['product-type', 'which-material', 'how-many', 'garage-door-type', 'type-produit', 'sun-shade-type', 'window-type'],
                            status: 'inactive',
                        },
                        {
                            number: 2,
                            name: '2. Type de projet',
                            acceptedSteps: ['project-type'],
                            status: 'inactive',
                        },
                        {
                            number: 3,
                            name: '3. Localisation',
                            acceptedSteps: ['location'],
                            status: 'inactive',
                        },
                        {
                            number: 4,
                            name: '4. Coordonnées',
                            acceptedSteps: ['coordinates'],
                            status: 'inactive',
                        },
                    ]

                    if (this.$store.global.isMobile) {
                        // Hide base progress bar
                        document.querySelector('.progress-bar')?.classList.add('hidden');
                        // Display the progress steps
                        this.displayMobileQuotationProgressSteps = true
                    } else {
                        // Hide base progress bar
                        document.querySelector('.progress-bar')?.classList.add('hidden');
                        // Display the progress steps
                        this.displayProgressSteps = true
                        //Display a version of the progress steps between mobile and desktop layout
                        if (window.matchMedia('(min-width: 1024px) and (max-width: 1500px)').matches) {
                            this.progressStepsCustom = true
                        }
                    }
                },
                // END ABTEST SCRIPTS
                appointmentDesktopProgressBar() {
                    // Hide base progress bar
                    document.querySelector('.progress-bar')?.classList.add('hidden');
                    // Display the progress steps
                    this.displayProgressSteps = true
                    //Display a version of the progress steps between mobile and desktop layout
                    if (window.matchMedia('(min-width: 1024px) and (max-width: 1500px)').matches) {
                        this.progressStepsCustom = true
                    }
                },
                transformLabel(item: HTMLElement) {
                    const input = item.querySelector('input');
                    const textArea = item.querySelector('textarea');
                    item.classList.add('floating-label')
                    if (input) {
                        input.addEventListener('blur', () => {
                            if (input.value.trim() === "") {
                                item.classList.remove('floating-label')
                            }
                        })
                    }
                    if (textArea) {
                        textArea.addEventListener('blur', () => {
                            if (textArea.value.trim() === "") {
                                item.classList.remove('floating-label')
                            }
                        })
                    }
                },
                handleMultipleClick() {
                    //Make next btn disable
                    this.buttonsDisabled.productsInterested = true;
                    //Get clicked choice
                    this.stepChoice = this.$el;
                    //Get stepChoice key
                    this.stepChoiceKey = this.stepChoice.getAttribute('choice');
                    //Make styled/un-styled choice and push/remove from choice array
                    if (!this.choice.active) {
                        //Make choice active
                        this.choice.active = true;
                        //Add to choices array
                        this.mulptipleCheckItems.push(' ' + this.choice.name);
                        this.mulptipleCheckDatas.push(this.choice.key);
                        this.arrayChoice[this.step.name] = this.mulptipleCheckItems;
                    } else {
                        //Make choice inactive
                        this.choice.active = false;
                        this.mulptipleCheckItems = this.mulptipleCheckItems.filter((e: string) => e !== ' ' + this.choice.name);
                        this.mulptipleCheckDatas = this.mulptipleCheckDatas.filter((e: string) => e !== ' ' + this.choice.key);
                        this.arrayChoice[this.step.name] = this.mulptipleCheckItems;
                    }
                    if (this.mulptipleCheckItems.length != 0) {
                        //Make next btn disable
                        this.buttonsDisabled.productsInterested = false;
                    }
                },
                handleMultipleCheckNext() {
                    this.formData.delete(this.step.name + '[]');
                    this.mulptipleCheckDatas = []

                    if (this.arrayChoice[this.step.name] == '') {
                        this.step.choices.forEach((item: MultipleCheckChoice) => {
                            if (item.active) {
                                this.mulptipleCheckItems = this.mulptipleCheckItems.filter((e: string) => e !== ' ' + item.name);
                                this.mulptipleCheckItems.push(' ' + item.name);

                                this.mulptipleCheckDatas = this.mulptipleCheckDatas.filter((e: string) => e !== item.key);
                                this.mulptipleCheckDatas.push(item.key);
                            }
                        });
                        this.arrayChoice[this.step.name] = this.mulptipleCheckItems;
                    } else {
                        this.step.choices.forEach((item: MultipleCheckChoice) => {
                            if (item.active) {
                                this.mulptipleCheckItems = this.mulptipleCheckItems.filter((e: string) => e !== ' ' + item.name);
                                this.mulptipleCheckItems.push(' ' + item.name);

                                this.mulptipleCheckDatas = this.mulptipleCheckDatas.filter((e: string) => e !== item.key);
                                this.mulptipleCheckDatas.push(item.key);
                            }
                        });
                        this.arrayChoice[this.step.name] = this.mulptipleCheckItems;
                        const test: Array<object> = []
                        test.push(this.mulptipleCheckItems)
                        this.sendEventStep(this.formName, this.step, test)
                    }
                    this.mulptipleCheckDatas.forEach((item: string) => {
                        this.formData.append(this.step.name + '[]', item);
                    });
                    //Set loading true
                    this.loading = true;
                    //Get nextStep key
                    this.nextStepKey = this.step.multipleChoicesNextStep;
                    //Go next step
                    setTimeout(() => {
                        this.prevSteps.push(this.step);
                        this.nextStep();
                    }, 200);
                },
                handleMultipleCheckNextABtest() {
                    this.formData.delete(this.step.name + '[]');
                    this.mulptipleCheckDatas = []

                    if (this.arrayChoice[this.step.name] == '') {
                        this.step.choices.forEach((item: MultipleCheckChoice) => {
                            if (item.active) {
                                this.mulptipleCheckItems = this.mulptipleCheckItems.filter((e: string) => e !== ' ' + item.name);
                                this.mulptipleCheckItems.push(' ' + item.name);

                                this.mulptipleCheckDatas = this.mulptipleCheckDatas.filter((e: string) => e !== item.key);
                                this.mulptipleCheckDatas.push(item.key);
                            }
                        });
                        this.arrayChoice[this.step.name] = this.mulptipleCheckItems;
                    } else {
                        this.step.choices.forEach((item: MultipleCheckChoice) => {
                            if (item.active) {
                                this.mulptipleCheckItems = this.mulptipleCheckItems.filter((e: string) => e !== ' ' + item.name);
                                this.mulptipleCheckItems.push(' ' + item.name);

                                this.mulptipleCheckDatas = this.mulptipleCheckDatas.filter((e: string) => e !== item.key);
                                this.mulptipleCheckDatas.push(item.key);
                            }
                        });
                        this.arrayChoice[this.step.name] = this.mulptipleCheckItems;
                        const test: Array<object> = []
                        test.push(this.mulptipleCheckItems)
                        this.sendEventStep(this.formName, this.step, test)
                    }
                    this.mulptipleCheckDatas.forEach((item: string) => {
                        this.formData.append(this.step.name + '[]', item);
                    });
                    //Set loading true
                    this.loading = true;
                    //Get nextStep key
                    this.nextStepKey = 'project-type';
                    //Go next step
                    setTimeout(() => {
                        this.prevSteps.push(this.step);
                        this.nextStep();
                    }, 200);
                },
                handleMultipleClickPrevStep(data) {
                    this.step = data;
                    //Make next btn disable
                    this.disabled = true;
                    //Get clicked choice
                    this.stepChoice = this.$el;
                    //Get stepChoice key
                    this.stepChoiceKey = this.stepChoice.getAttribute('choice');
                    //Make styled/un-styled choice and push/remove from choice array
                    if (!this.choice.active) {
                        //Make choice active
                        this.choice.active = true;
                        //Add to choices array
                        this.mulptipleCheckItems.push(' ' + this.choice.name);
                        this.mulptipleCheckDatas.push(this.choice.key);
                        this.arrayChoice[this.step.name] = this.mulptipleCheckItems;
                    } else {
                        //Make choice inactive
                        this.choice.active = false;
                        this.mulptipleCheckItems = this.mulptipleCheckItems.filter((e: string) => e !== ' ' + this.choice.name);
                        this.mulptipleCheckDatas = this.mulptipleCheckDatas.filter((e: string) => e !== ' ' + this.choice.key);
                        this.arrayChoice[this.step.name] = this.mulptipleCheckItems;
                    }
                    if (this.mulptipleCheckItems.length != 0) {
                        //Make next btn disable
                        this.disabled = false;
                    }
                },
                handleMultipleCheckNextPrevStep() {
                    this.formData.delete(this.step.name + '[]');
                    this.mulptipleCheckDatas = []

                    if (this.arrayChoice[this.step.name] == '') {
                        this.step.choices.forEach((item: MultipleCheckChoice) => {
                            if (item.active) {
                                this.mulptipleCheckItems = this.mulptipleCheckItems.filter((e: string) => e !== ' ' + item.name);
                                this.mulptipleCheckItems.push(' ' + item.name);

                                this.mulptipleCheckDatas = this.mulptipleCheckDatas.filter((e: string) => e !== item.key);
                                this.mulptipleCheckDatas.push(item.key);
                            }
                        });
                        this.arrayChoice[this.step.name] = this.mulptipleCheckItems;
                    }
                    this.mulptipleCheckDatas.forEach((item: MultipleCheckChoice) => {
                        this.formData.append(this.step.name + '[]', item);
                    });
                    //Delete in prevSteps, arrayChoice and dataChoice all infos after actual step
                    const targetName = this.step.name;
                    const targetIndex = this.prevSteps.findIndex((obj) => obj.name === targetName);
                    //Set loading true
                    this.loading = true;
                    //Get nextStep key
                    this.nextStepKey = this.step.multipleChoicesNextStep;
                    //Go next step
                    setTimeout(() => {
                        this.nextStep(targetIndex);
                    }, 200);
                },
                handleClick() {
                    //Set loading true
                    this.loading = true;
                    //Reset choices style
                    this.step.choices.forEach((item: SimpleCheckChoice) => {
                        item.active = false;
                    });
                    //Get clicked choice
                    // test for this AB Test : runABtestDeleteRdvStep
                    if (this.skipAppointmentStep && this.step.name == 'meetMethod') {
                        this.stepChoice = document.querySelector('div[choice="home"]');
                    } else {
                        this.stepChoice = this.$el;
                    }
                    //Get stepChoice key
                    // test for this AB Test : runABtestDeleteRdvStep
                    if (this.skipAppointmentStep && this.step.name == 'meetMethod') {
                        this.stepChoiceKey = 'home';
                    } else {
                        this.stepChoiceKey = this.stepChoice.getAttribute('choice');
                    }
                    //Get stepChoice object
                    this.choice = this.step.choices.find((item: SimpleCheckChoice) => item.key === this.stepChoiceKey);

                    if (this.choice?.hasGoToUrl) {
                        this.loading = false
                        const goToUrl = this.choice?.goToUrl;

                        if (goToUrl) {
                            const userData = getUserData();
                            if (userData && userData.shop && userData.shop.url) {
                                window.location.href = goToUrl.replace('SHOP_NAME', userData.shop.name);
                            }
                        }
                    } else {
                        //Make styled choice
                        this.choice.active = true;
                        //Get nextStep key about clicked choice
                        this.nextStepKey = this.choice.nextStep;
                        //Push in array the choice
                        this.arrayChoice[this.step.name] = this.choice.name;
                        //Prepare formData
                        this.dataChoice[this.step.name] = this.choice.key;
                        //Run function to load next step
                        if (this.choice.data.steps) {
                            this.totalSteps = this.choice.data.steps;
                        }
                        // Run send event in data layer function
                        this.sendEventStep(this.formName, this.step, this.choice)
                        console.log(this.step.name);
                        setTimeout(() => {
                            this.prevSteps.push(this.step);
                            this.nextStep();
                            if(this.$store.ab.skipCPstepState) {
                                if(this.step.name == 'location') {
                                    this.handleClickField()
                                }
                            }
                            
                        }, 200);
                        // AB Test - 86c9ntpxg skip project-type step
                        if(this.$store.ab.skipProjectType) {
                            setTimeout(() => {
                                if (this.step.name == 'project-type') {
                                    document.querySelector<HTMLElement>('[choice="renovation"]')?.click();
                                }
                            }, 200)
                        }
                    }
                },
                handleClickPrevStep(data) {
                    this.step = data;
                    //Reset choices style
                    this.step.choices.forEach((item: SimpleCheckChoice) => {
                        item.active = false;
                    });
                    //Get clicked choice
                    this.stepChoice = this.$el;
                    //Get stepChoice key
                    this.stepChoiceKey = this.stepChoice.getAttribute('choice');
                    //Get stepChoice object
                    this.choice = this.step.choices.find((item: SimpleCheckChoice) => item.key === this.stepChoiceKey);
                    //Make styled choice
                    this.choice.active = true;
                    //Get nextStep key about clicked choice
                    this.nextStepKey = this.choice.nextStep;
                    //Push in array the choice
                    this.arrayChoice[this.step.name] = this.choice.name;
                    //Prepare formData
                    this.dataChoice[this.step.name] = this.choice.key;
                    //Run function to load next step
                    if (this.choice.data.steps) {
                        this.totalSteps = this.choice.data.steps;
                    }
                    //Delete in prevSteps, arrayChoice and dataChoice all infos after actual step
                    const targetName = this.step.name;
                    const targetIndex = this.prevSteps.findIndex((obj) => obj.name === targetName);
                    if (targetIndex !== -1) {
                        this.prevSteps.splice(targetIndex + 1);
                    }

                    let foundArrayChoice = false;
                    for (const key in this.arrayChoice) {
                        if (foundArrayChoice) {
                            delete this.arrayChoice[key];
                        }
                        if (key === targetName) {
                            foundArrayChoice = true;
                        }
                    }

                    let foundDataChoice = false;
                    for (const key in this.dataChoice) {
                        if (foundDataChoice) {
                            delete this.dataChoice[key];
                        }
                        if (key === targetName) {
                            foundDataChoice = true;
                        }
                    }
                    //Run next step
                    setTimeout(() => {
                        this.nextStep(targetIndex + 1);
                    }, 200);
                },
                handleClickField() {
                    try {
                        const nextStep = this.steps[this.nextStepKey];
                        if (nextStep.data !== undefined && nextStep.data.length != 0) {
                            this.stepBackground = nextStep.data.background.path;
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    //AB test checkmark
                    if (this.enableCheckMark) {
                        setTimeout(() => {
                            const textArea = document.querySelector('textarea') as HTMLTextAreaElement;
                            if (textArea && textArea.parentNode && textArea.parentNode.parentNode) {
                                const label = textArea.parentNode.parentNode.querySelector('label') as HTMLLabelElement;
                                const labelContent = label.innerText
                                if (label) {
                                    label.innerText = `${labelContent} (facultatif)`
                                }
                            }
                        }, 400)

                    }
                    //Set loading true
                    this.loading = true;
                    //Test for this AB Test : runABtestDeleteRdvStep
                    if (this.skipAppointmentStep && this.step.name == 'location') {
                        //Get nextStep key
                        this.nextStepKey = 'availability';
                    } else {
                        //Get nextStep key
                        this.nextStepKey = this.step.fieldsNextStep;
                    }

                    //Get nextStep key
                    //this.nextStepKey = this.step.fieldsNextStep;
                    //Make array with all inputs fields in the step
                    const skipStepInputs: any = document.querySelector('.fieldsCurrent')
                    if (skipStepInputs) {
                        this.allInputs = skipStepInputs.querySelectorAll('.quotationInput');
                    } else {
                        this.allInputs = document.querySelectorAll('.quotationInput');
                    }
                    //Push in array the choice
                    this.allInputs.forEach((item: HTMLInputElement) => {
                        //Prepare formData
                        if (item.value != '') {
                            this.arrayChoice[this.step.name] = item.value;
                            this.dataChoice[this.step.name] = item.value;
                        }
                    });
                    //If input type file
                    const fileInput = document.querySelector('[type="file"]') as HTMLInputElement;
                    if (fileInput) {
                        Array.from(fileInput.files as FileList).forEach((file: File) => {
                            this.formData.set('images[]', file, file.name);
                        });
                    }
                    //Go next step
                    setTimeout(() => {
                        if (this.step.name === 'projectDescription') {
                            const projectDescription = document.querySelector('textarea[name="projectDescription"]') as HTMLTextAreaElement | null;
                            if (projectDescription) {
                                this.step.fields[0].value = projectDescription.value;
                            }
                        }
                        this.prevSteps.push(this.step);
                        this.nextStep();
                    }, 200);
                    // Remove "*" from address input label when address input isn't required (AB TEST)
                    setTimeout(() => {
                        const body = document.querySelector('body') as HTMLBodyElement;
                        const isRequiredAddress = body.dataset.requiredAddress == 'true' ? true : false
                        if (!isRequiredAddress) {
                            const inputAddress = document.querySelector('input[name="address"]')
                            if (inputAddress && inputAddress.parentNode && inputAddress.parentNode.parentNode) {
                                const label = inputAddress.parentNode.parentNode.querySelector('label')
                                if (label) {
                                    label.innerHTML = label.innerHTML.slice(0, -1)
                                }
                            }
                        }
                    }, 200)
                },
                handleClickFieldPrevSteps(data) {
                    this.step = data;
                    //Set loading true
                    this.loading = true;
                    //Get nextStep key
                    this.nextStepKey = this.step.fieldsNextStep;
                    //Delete in prevSteps, arrayChoice and dataChoice all infos after actual step
                    const targetName = this.step.name;
                    const targetIndex = this.prevSteps.findIndex((obj) => obj.name === targetName);
                    if (targetIndex !== -1) {
                        this.prevSteps.splice(targetIndex + 1);
                    }

                    let foundArrayChoice = false;
                    for (const key in this.arrayChoice) {
                        if (foundArrayChoice) {
                            delete this.arrayChoice[key];
                        }
                        if (key === targetName) {
                            foundArrayChoice = true;
                        }
                    }

                    let foundDataChoice = false;
                    for (const key in this.dataChoice) {
                        if (foundDataChoice) {
                            delete this.dataChoice[key];
                        }
                        if (key === targetName) {
                            foundDataChoice = true;
                        }
                    }

                    this.allInputs = document.querySelectorAll('.quotationInput');
                    //Push in array the choice
                    this.allInputs.forEach((item: HTMLInputElement) => {
                        //Prepare formData
                        if (item.value != '') {
                            this.arrayChoice[this.step.name] = item.value;
                            this.dataChoice[this.step.name] = item.value;
                        }
                    });
                    //If input type file
                    const fileInput = document.querySelector('[type="file"]') as HTMLInputElement;
                    if (fileInput) {
                        Array.from(fileInput.files as FileList).forEach((file: File) => {
                            this.formData.set('images[]', file, file.name);
                        });
                    }
                    //Go next step
                    setTimeout(() => {
                        this.nextStep(targetIndex);
                    }, 200);
                },
                handlePrevious(): void {
                    //set loading true
                    this.loading = true;
                    setTimeout(() => {
                        this.previousStep();
                    }, 200);
                },
                validateLength(event: KeyboardEvent & { target: HTMLInputElement }) {
                    this.nbInputs = event.target.value.length;
                    this.nbOfChars = this.nbInputs

                    if (this.$store.global.isMobile) {
                        event.target.style.height = "98px";

                    } else {
                        event.target.style.height = "82px";
                    }
                },
                lengthLimit(maxLength: number, item: any, event: KeyboardEvent & { target: HTMLInputElement }) {
                    let wrapper: any = null;
                    if (item.parentElement.querySelector('#lengthControl')) {
                        wrapper = item.parentElement.querySelector('#lengthControl')
                    } else {
                        wrapper = item.parentElement.parentElement.querySelector('#lengthControl')
                    }
                    if (event.target.value.length === maxLength) {
                        if (wrapper.classList.contains('text-secondary-02')) {
                            return;
                        } else {
                            wrapper.classList.add('text-secondary-02')
                        }
                    } else {
                        if (wrapper.classList.contains('text-secondary-02')) {
                            wrapper.classList.remove('text-secondary-02')
                        }
                    }
                    wrapper.innerHTML = event.target.value.length + '/' + maxLength
                },
                validateInput(event: KeyboardEvent & { target: HTMLInputElement }): void {
                    this.nbInputs = event.target.value.length;
                    if (this.nbInputs >= 1) {
                        this.disabled = false;
                        if (!this.step.isLastStep && !this.step.required && this.step.skipStepLabel) {
                            this.changeBtnType = true;
                        }
                        return;
                    }
                    if (this.nbInputs === 0) {
                        if (!this.step.isLastStep && !this.step.required && this.step.skipStepLabel) {
                            this.changeBtnType = false;
                        }
                        return;
                    }
                },
                changeBtn(data: FileInputResponse): void {
                    if ('files' in data) {
                        if (data.files && data.files.length != 0) {
                            this.changeBtnType = true;
                        }
                        if (data.files && data.files.length != 0 && this.nbInputs === 0) {
                            this.changeBtnType = true;
                        }
                        if (data.files && data.files.length === 0) {
                            this.changeBtnType = false;
                        }
                        if (data.files && data.files.length === 0 && this.nbInputs === 0) {
                            this.changeBtnType = false;
                        }
                    }
                },
                nextStep(stepNb?: any) {
                    // ABTEST OPINION
                    this.displayReviews = false;
                    //Init displayChoice to false
                    this.displayChoices = false;
                    //Init displayFields to false
                    this.displayFields = false;
                    //It is not he first step
                    this.isInitStep = false;
                    //Make step about previous clicked element
                    this.step = this.steps[this.nextStepKey];
                    //Push hash in url
                    if (stepNb != undefined) {
                        if (stepNb === 0) {
                            stepNb = 1
                        }
                        this.stepNumber = stepNb
                        window.location.hash = 'etape' + this.stepNumber;
                        // Run send data layer function
                        this.sendDataLayer(this.formName, this.stepNumber, this.step.tag)
                    } else {
                        this.stepNumber = this.stepNumber + 1;
                        window.location.hash = 'etape' + this.stepNumber;
                        // Run send data layer function
                        this.sendDataLayer(this.formName, this.stepNumber, this.step.tag)
                    }
                    // Run send data layer function
                    // this.sendDataLayer(this.formName, this.stepNumber, this.step.tag)

                    //Push step and choices in history
                    this.makeHistory();
                    //Check if step have choices or fields
                    if (this.step.choices.length != 0) {
                        this.displayChoices = true;
                    }
                    if (this.step.fields.length != 0) {
                        this.displayFields = true;
                    }
                    //Get background image
                    if (this.choice && this.choice.data && this.choice.data.length != 0 && this.choice.data.background) {
                        this.stepBackground = this.choice.data.background.path;
                    }
                    if (this.step.data.length != 0) {
                        this.stepBackground = this.step.data.background.path;
                    }

                    if (this.step.canSelectMultipleChoices && this.arrayChoice[this.step.name] == '') {
                        this.disabled = true;
                    }
                    //Run progressBar
                    this.currentStep = this.currentStep + 1;
                    this.makeProgress();
                    //  In mobile, scroll window into new step
                    if (this.$store.global.isMobile && this.$refs.myStep) {
                        this.$nextTick(() => {
                            window.scrollTo({ top: this.$refs.myStep.offsetTop, left: 0, behavior: 'smooth' });
                        });
                    }
                    if (this.step.canSelectMultipleChoices) {
                        //Make next btn disable
                        this.disabled = true;
                    }
                    //Disable loading state
                    this.loading = false;

                },
                previousStep() {
                    //Go previous step
                    this.arrayChoice[this.step.name] = '';
                    // Test for this AB Test : runABtestDeleteRdvStep
                    if (this.skipAppointmentStep && this.step.name == 'availability') {

                        this.prevSteps.pop();
                        this.step = this.steps['location'];
                        this.prevSteps.pop();

                    } else {
                        this.step = this.prevSteps.pop();
                        // AB test « skip CP step » : l'étape location est zappée à l'aller, on la saute
                        // aussi au retour pour ne pas retomber dessus depuis l'étape coordonnées.
                        if (this.$store.ab.skipCPstepState && this.step && this.step.name === 'location') {
                            const beforeLocation = this.prevSteps.pop();
                            if (beforeLocation) {
                                this.step = beforeLocation;
                                this.stepNumber = this.stepNumber - 1;
                            }
                        }
                        // AB Test - 86c9ntpxg skip project-type step
                        if (this.$store.ab.skipProjectType && this.step && this.step.name == 'project-type') {
                            this.step = this.prevSteps.pop();
                        }
                    }
                    this.stepNumber = this.stepNumber - 1;
                    if (this.stepNumber == 0) {
                        window.location.hash = '';
                    } else {
                        window.location.hash = 'etape' + this.stepNumber;
                    }
                    //Push step and choices in history
                    this.makeHistory();
                    //Init displayChoice to false
                    this.displayChoices = false;
                    //Init displayFields to false
                    this.displayFields = false;
                    //Check if step have choices or fields
                    if (this.step.choices.length != 0) {
                        this.displayChoices = true;
                    }
                    if (this.step.fields.length != 0) {
                        this.displayFields = true;
                    }
                    //Get background image
                    if (this.step.data.length != 0) {
                        this.stepBackground = this.step.data.background.path;
                    }
                    //Delete choice from prev step choice
                    this.arrayChoice[this.step.name] = '';
                    delete this.dataChoice[this.step.name];
                    //Run progressBar
                    this.currentStep = this.currentStep - 1;
                    this.makeProgress();
                    //Set loading to false
                    this.loading = false;
                    if (this.step.name === 'location') {
                        this.initInputContent = getUserData();
                        if (this.initInputContent) {
                            setTimeout(() => {
                                this.inputElement = document.querySelector('.inputElement');
                                try {
                                    this.fillFromLocal(this.initInputContent);
                                } catch (e) {
                                    console.warn('fillFromLocal not available');
                                }
                            }, 200);
                        }
                    }
                    // Run send data layer function
                    // this.sendDataLayer(this.formName, this.stepNumber, this.step.tag)
                    // Run send event to data leyer
                    this.sendEventPrevious(this.formName, this.stepNumber)
                },
                makeHistory() {
                    this.historyContent = [];
                    if (this.step.choices.length != 0) {
                        this.displayChoices = true;
                    }
                    if (this.step.fields.length != 0) {
                        this.displayFields = true;
                    }
                    this.historyContent.push(this.step);
                    this.historyContent.push(this.arrayChoice);
                    this.historyContent.push(this.prevSteps);
                    this.historyContent.push(this.stepNumber);
                    this.historyContent.push(this.displayChoices);
                    this.historyContent.push(this.displayFields);
                    this.historyContent = JSON.stringify(this.historyContent);
                    history.pushState(this.historyContent, 'etape', window.location.hash);
                },
                makeProgress() {
                    if (history.state && !this.fromAbTest) {
                        const state = JSON.parse(history.state);
                        this.currentStep = state[3];
                        if (state[3] == 0 || this.step == this.initStep) {
                            this.currentStep = 1
                            this.totalSteps = 10
                        }
                    }
                    this.progressBarWidth = `${(this.currentStep / this.totalSteps) * 100}%`;
                },
                validateLastStep(item: string) {
                    const civility = document.querySelectorAll('[name="civility"]:checked') as NodeListOf<HTMLInputElement>;
                    //AB Test not required address
                    const body = document.querySelector('body') as HTMLBodyElement;
                    const isRequiredAddress = body.dataset.requiredAddress == 'true'

                    if (civility.length) {
                        this.civilityValid = true
                    }

                    //Vérification lastName
                    if (item == 'lastname') {
                        const lastname = document.querySelector('[name="lastname"]') as HTMLInputElement;
                        const inputSpanLastName: any = lastname.parentElement?.parentElement?.querySelector('span')

                        if ((lastname && lastname.value == '') && inputSpanLastName) {
                            inputSpanLastName.innerHTML = 'Ce champ est requis.'
                            this.lastNameValid = false
                        } else {
                            if ((lastname && /\d/.test(lastname.value)) && inputSpanLastName) {
                                inputSpanLastName.innerHTML = 'Ce champ ne doit pas contenir de chiffre.'
                                this.lastNameValid = false
                            } else if ((lastname && lastname.value.length > 150) && inputSpanLastName) {
                                inputSpanLastName.innerHTML = '150 caractères maximum.'
                                this.lastNameValid = false
                            } else if (inputSpanLastName) {
                                inputSpanLastName.innerHTML = ''
                                this.lastNameValid = true
                            }
                        }
                    }

                    if (item == 'firstname') {
                        //Vérification firstName
                        const firstname = document.querySelector('[name="firstname"]') as HTMLInputElement;
                        const inputSpanFirstName: any = firstname.parentElement?.parentElement?.querySelector('span')

                        if ((firstname && firstname.value.length == 0) && inputSpanFirstName) {
                            inputSpanFirstName.innerHTML = 'Ce champ est requis.'
                            this.firstNameValid = false
                        } else {
                            if ((firstname && /\d/.test(firstname.value)) && inputSpanFirstName) {
                                inputSpanFirstName.innerHTML = 'Ce champ ne doit pas contenir de chiffre.'
                                this.firstNameValid = false
                            } else if ((firstname && firstname.value.length > 150) && inputSpanFirstName) {
                                inputSpanFirstName.innerHTML = '150 caractères maximum.'
                                this.firstNameValid = false
                            } else if (inputSpanFirstName) {
                                inputSpanFirstName.innerHTML = ''
                                this.firstNameValid = true
                            }
                        }
                    }

                    if (item == 'email') {
                        //Vérification email
                        const email = document.querySelector('[name="email"]') as HTMLInputElement;
                        const inputSpanEmail: any = email.parentElement?.parentElement?.querySelector('span')
                        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                        email.addEventListener("blur", () => {
                            if (email && email.value.trim() !== '' && emailPattern.test(email.value) && inputSpanEmail) {
                                inputSpanEmail.innerHTML = ''
                                this.emailValid = true
                            } else if (inputSpanEmail) {
                                this.emailValid = false
                                inputSpanEmail.innerHTML = 'Ce champ n\'est pas complet ou erroné.'
                            }
                        });

                        if (email && email.value.trim() !== '' && emailPattern.test(email.value) && inputSpanEmail) {
                            inputSpanEmail.innerHTML = ''
                            this.emailValid = true
                        } else if (inputSpanEmail) {
                            this.emailValid = false
                            inputSpanEmail.innerHTML = 'Ce champ n\'est pas complet ou erroné.'
                        }

                        if (email.value.length > 150 && inputSpanEmail) {
                            inputSpanEmail.innerHTML = '150 caractères maximum.'
                            this.emailValid = false
                        }
                    }

                    if (item == 'tel') {
                        //Vérification téléphone
                        const phone = document.querySelector('[name="phone"]') as HTMLInputElement;
                        const inputSpanTel = phone.parentElement?.parentElement?.querySelector('span.text-alert-danger') as HTMLSpanElement | null;
                        const store = getPhonePrefixStore();
                        const result = isPhoneInputValid(phone.value, store.enabled, store.country);

                        if (!result.valid && inputSpanTel) {
                            inputSpanTel.innerHTML = result.message;
                            this.telValid = false;
                            this.phoneCheckValidState = false;
                        } else if (inputSpanTel) {
                            inputSpanTel.innerHTML = '';
                            this.telValid = true;
                            this.phoneCheckValidState = true;
                        }
                    }

                    if (isRequiredAddress) {
                        if (document.querySelector('[name="address"]')) {
                            if (item == 'text') {
                                //Vérification text(address)
                                const address = document.querySelector('[name="address"]') as HTMLInputElement;
                                const inputSpanAddress: any = address.parentElement?.parentElement?.querySelector('span')

                                if ((address && address.value.length == 0) && inputSpanAddress) {
                                    inputSpanAddress.innerHTML = 'Ce champ est requis.'
                                    this.addressValid = false
                                } else if ((address && address.value.length > 300) && inputSpanAddress) {
                                    inputSpanAddress.innerHTML = '300 caractères maximum.'
                                    this.addressValid = false
                                } else if (inputSpanAddress) {
                                    inputSpanAddress.innerHTML = ''
                                    this.addressValid = true
                                }
                            }
                        }
                    } else {
                        const address = document.querySelector('[name="address"]') as HTMLInputElement;
                        if (address) {
                            const inputSpanAddress: any = address.parentElement?.parentElement?.querySelector('span')

                            if (address.value.length > 300 && inputSpanAddress) {
                                inputSpanAddress.innerHTML = '300 caractères maximum.'
                                this.addressValid = false
                            } else {
                                this.addressValid = true
                            }
                        }
                    }

                    // Only Skip CP adds location to coordinates; baseline mobile also displays the previous location step.
                    const location = this.$store.ab.skipCPstepState ? getVisibleInput('location') : null;
                    // Read the value on every validation, including values restored without input events.
                    this.locationValid = !location || isValidZipCityLocation(location.value);
                    if (item == 'location' && location) {
                        const inputSpanLocation = location.parentElement?.parentElement?.querySelector('span.text-alert-danger');
                        if (inputSpanLocation) {
                            inputSpanLocation.innerHTML = this.locationValid ? ''
                                : 'Veuillez sélectionner une ville dans la liste ou saisir un code postal suivi de la ville.';
                        }
                    }

                    // Check if all inputs are validated (lastname, firstname, email, phone, civility, address/location si présents)
                    const hasAddressField = !!document.querySelector('[name="address"]');
                    const hasLocationField = !!location;
                    const coreValid = this.civilityValid && this.lastNameValid && this.firstNameValid && this.telValid && this.emailValid;
                    const addressOk = !hasAddressField || this.addressValid;
                    const locationOk = !hasLocationField || this.locationValid;

                    this.buttonsDisabled.personalInfos = !(coreValid && addressOk && locationOk);
                },
                validateLastStepGlobal() {
                    //AB Checkmark and xmark on validation
                    if (this.enableCheckMark) {
                        this.isValidationGlobalRunned = true
                    }

                    //AB Test not required address
                    const body = document.querySelector('body') as HTMLBodyElement;
                    const isRequiredAddress = body.dataset.requiredAddress == 'true'

                    let validatedInputs = 0;

                    const civility = document.querySelectorAll('[name="civility"]:checked') as NodeListOf<HTMLInputElement>;
                    if (civility.length) {
                        validatedInputs++;
                    }

                    //Vérification lastName
                    const lastname = document.querySelector('[name="lastname"]') as HTMLInputElement;
                    const inputSpanLastName: any = lastname.parentElement?.parentElement?.querySelector('span')

                    if ((lastname && lastname.value == '') && inputSpanLastName) {
                        inputSpanLastName.innerHTML = 'Ce champ est requis.'
                    } else {
                        if ((lastname && /\d/.test(lastname.value)) && inputSpanLastName) {
                            inputSpanLastName.innerHTML = 'Ce champ ne doit pas contenir de chiffre.'
                        } else if (inputSpanLastName) {
                            inputSpanLastName.innerHTML = ''
                            validatedInputs++;
                        }
                    }

                    //Vérification firstName
                    const firstname = document.querySelector('[name="firstname"]') as HTMLInputElement;
                    const inputSpanFirstName: any = firstname.parentElement?.parentElement?.querySelector('span')

                    if ((firstname && firstname.value.length == 0) && inputSpanFirstName) {
                        inputSpanFirstName.innerHTML = 'Ce champ est requis.'
                    } else {
                        if ((firstname && /\d/.test(firstname.value)) && inputSpanFirstName) {
                            inputSpanFirstName.innerHTML = 'Ce champ ne doit pas contenir de chiffre.'
                        } else if (inputSpanFirstName) {
                            inputSpanFirstName.innerHTML = ''
                            validatedInputs++;
                        }
                    }

                    //Vérification email
                    const email = document.querySelector('[name="email"]') as HTMLInputElement;
                    const inputSpanEmail: any = email.parentElement?.parentElement?.querySelector('span')
                    email.addEventListener("blur", () => {
                        if (email && email.value.trim() !== '' && email.value.includes('@') && email.value.includes('.') && inputSpanEmail) {
                            inputSpanEmail.innerHTML = ''
                            validatedInputs++;
                        } else if (inputSpanEmail) {
                            inputSpanEmail.innerHTML = 'Ce champ n\'est pas complet ou erroné.'
                        }
                    });

                    if (email && email.value.trim() !== '' && email.value.includes('@') && email.value.includes('.') && inputSpanEmail) {
                        inputSpanEmail.innerHTML = ''
                        validatedInputs++;
                    } else if (inputSpanEmail) {
                        inputSpanEmail.innerHTML = 'Ce champ n\'est pas complet ou erroné.'
                    }

                    //Vérification téléphone
                    const phone = document.querySelector('[name="phone"]') as HTMLInputElement;
                    const inputSpanTel = phone.parentElement?.parentElement?.querySelector('span.text-alert-danger') as HTMLSpanElement | null;
                    const store = getPhonePrefixStore();
                    const result = isPhoneInputValid(phone.value, store.enabled, store.country);

                    if (!result.valid && inputSpanTel) {
                        inputSpanTel.innerHTML = result.message;
                        this.telValid = false;
                        this.phoneCheckValidState = false;
                    } else if (inputSpanTel) {
                        inputSpanTel.innerHTML = '';
                        this.telValid = true;
                        this.phoneCheckValidState = true;
                        validatedInputs++;
                    }

                    //Vérification adresse
                    if (isRequiredAddress) {
                        if (document.querySelector('[name="address"]')) {
                            const address = document.querySelector('[name="address"]') as HTMLInputElement;
                            const inputSpanAddress: any = address.parentElement?.parentElement?.querySelector('span')

                            if ((address && address.value == '') && inputSpanAddress) {
                                inputSpanAddress.innerHTML = 'Ce champ est requis.'
                            } else if (inputSpanAddress) {
                                inputSpanAddress.innerHTML = ''
                                validatedInputs++;
                            }
                        }
                    }

                    //Vérification location (AB Test "Skip CP step")
                    const location = this.$store.ab.skipCPstepState ? getVisibleInput('location') : null;
                    if (location) {
                        const inputSpanLocation = location.parentElement?.parentElement?.querySelector('span.text-alert-danger');
                        if (!isValidZipCityLocation(location.value)) {
                            if (inputSpanLocation) {
                                inputSpanLocation.innerHTML = 'Veuillez sélectionner une ville dans la liste ou saisir un code postal suivi de la ville.';
                            }
                            this.locationValid = false;
                        } else {
                            if (inputSpanLocation) {
                                inputSpanLocation.innerHTML = '';
                            }
                            this.locationValid = true;
                            validatedInputs++;
                        }
                    }

                    // Check if all inputs are validated (lastname, firstname, email, phone, civility, address/location si présents)
                    const hasAddressField = !!document.querySelector('[name="address"]');
                    const hasLocationField = !!location;
                    const expectedValidatedInputs = 5 + (hasAddressField ? 1 : 0) + (hasLocationField ? 1 : 0);

                    if (validatedInputs === expectedValidatedInputs) {
                        this.buttonsDisabled.personalInfos = false;
                    } else {
                        window.scrollTo({ top: this.$refs.myStep.offsetTop - 70, left: 0, behavior: 'smooth' });
                        this.buttonsDisabled.personalInfos = true;
                    }
                },
                async createFormDatas(): Promise<void> {
                    if (this.loadingBtn) {
                        return;
                    }

                    //AB Test not required address
                    const body = document.querySelector('body') as HTMLBodyElement;
                    const isRequiredAddress = body.dataset.requiredAddress == 'true';

                    this.errorMessage = '';
                    //Prepare formData
                    //Make array with all inputs fields in the step
                    Array.from(document.querySelectorAll('.quotationInput') as NodeListOf<HTMLInputElement>).forEach((item: HTMLInputElement) => {
                        if (!['availability'].includes(item.name)) {
                            const store = getPhonePrefixStore();
                            this.dataChoice[item.name] = item.name === 'phone' && store.enabled
                                ? formatPhoneForCrm(item.value, store.country)
                                : item.value;
                        }
                    });

                    Object.keys(this.dataChoice).forEach((key) => {
                        if (key !== 'contactMethods') {
                            if (typeof this.dataChoice[key] !== 'object') {
                                this.formData.append(key, this.dataChoice[key]);
                            } else {
                                this.formData.append(key, JSON.stringify(this.dataChoice[key]));
                            }
                        }
                    });

                    const civility = document.querySelector('[name="civility"]:checked') as HTMLInputElement | null;

                    if (civility) {
                        this.formData.set('civility', civility.value);
                    }

                    const contactMethods = document.querySelectorAll('[type="checkbox"]:checked') as NodeListOf<HTMLInputElement>;

                    if (contactMethods.length) {
                        const arrayContactMethods: any = [];

                        contactMethods.forEach((contactMethod: HTMLInputElement) => {
                            if (contactMethod.value === 'email' || contactMethod.value === 'sms' || contactMethod.value === 'phone') {
                                this.formData.append('contactMethods[]', contactMethod.value);
                                // Run send event in data layer function
                                arrayContactMethods.push(contactMethod.value);
                                this.sendEventStep(this.formName, this.step, arrayContactMethods.length != 0 ? (arrayContactMethods.length > 1 ? (arrayContactMethods.length > 2 ? 'trois' : 'deux') : arrayContactMethods) : 'aucun');
                            }
                        });
                    }

                    const userData = getUserData();
                    const urlSearchParams = new URLSearchParams(window.location.search);
                    const hasLocationAlreadyBeenSelected = this.formData.get('location') !== null || urlSearchParams.get('no-location') === '1';

                    if (hasLocationAlreadyBeenSelected && userData && userData.localisation) {
                        try {
                            const { zip, city } = userData.localisation;
                            this.formData.set('location', (zip + ' ' + city).trim());
                        } catch (e) {
                            console.warn(e);
                        }
                    }

                    if (userData?.shop?.clientNumber) {
                        this.formData.set('location_shop', userData.shop.clientNumber);
                    }
                    addUtmToFormData(this.formData);
                    addQwamplifyToFormData(this.formData);
                    const formData = this.formData;
                    this.disabled = true;
                    this.loadingBtn = true;
                    let error: any = null;
                    try {
                        const formSent = await send(formData, isRequiredAddress ? this.sendUrl : this.sendUrl + ['?noAddressRequired=1']);
                        window.location.href = (formSent as ApiSuccess).confirmation;
                    } catch (e: unknown) {
                        const err = e as ApiError;
                        this.confirmation = false;
                        this.formError(err);
                        error = err
                    } finally {
                        if (error) {
                            this.loadingBtn = false;
                            this.disabled = false;
                        } else {
                            this.loadingBtn = true;
                            this.disabled = true;
                        }
                    }
                },
                formError(errors: ApiError): void {
                    this.errorMessage = '';
                    this.allInputs = document.querySelectorAll('.quotationInput');
                    this.allRadio = document.querySelectorAll('.quotationRadio');

                    this.allRadio.forEach((item: HTMLInputElement) => {
                        const span = (item.parentNode?.parentNode?.parentNode?.parentNode as HTMLDivElement).getElementsByTagName('span');
                        span[0].textContent = ''
                        Object.keys(errors).forEach((key) => {
                            if (item.name === key) {
                                if (span.length) {
                                    span[0].textContent = errors[key][0];
                                }
                            }
                        });
                    });

                    this.allInputs.forEach((item: HTMLInputElement) => {
                        const span = (item.parentNode?.parentNode as HTMLDivElement).getElementsByTagName('span')
                        span[0].textContent = ''
                        Object.keys(errors).forEach((key) => {
                            if (item.name === key) {
                                if (span.length) {
                                    span[0].textContent = errors[key][0];
                                }
                            }
                        });
                    });
                    // Send event for errors in data layer
                    sendEventDataLayer('click', 'tunnel-devis', 'erreur-formulaire', this.step.name, false, Object.keys(errors).length)
                },
                ////////////////////
                //Geoloc
                ////////////////////
                geolocMe2() {
                    this.enableStoreCard = false;
                    this.inputElement = document.querySelector('.inputElement');
                    this.geolocLoading = true;
                    this.loading = true;
                    //Reset input
                    this.inputElement.value = '';
                    this.inputElement.setAttribute('value', '');
                    this.launchGeoloc2();
                },
                async launchGeoloc2() {
                    if (navigator.geolocation) {
                        await navigator.geolocation.getCurrentPosition((position) => {
                            if (position) {
                                this.lat = position.coords.latitude;
                                this.lng = position.coords.longitude;
                                const newUrl = getGeoLocURL() + this.lat + ',' + this.lng;
                                fetch(newUrl)
                                    .then((response) => {
                                        if (!response.ok) {
                                            throw new Error(response.statusText);
                                        }
                                        return response.json();
                                    })
                                    .then((data) => {
                                        this.getLocation2(data);
                                    });
                            }
                        });
                    }
                },
                getLocation2(data: GetLocation) {
                    if (!data.results.length) {
                        alert('Votre position est introuvable');
                        this.geolocLoading = false;
                        return;
                    }
                    data.results.forEach((result) => {
                        const address_components = result.address_components;
                        address_components.forEach((address) => {
                            if (address.types[0] == 'postal_code') {
                                this.zipcode = address.short_name;
                            }
                            if (address.types[0] == 'locality') {
                                this.city = address.short_name;
                            }
                            this.geolocLoading = false;
                            this.inputElement.setAttribute('value', this.zipcode + ' ' + this.city);
                        });
                    });
                    this.searchFromGeoloc();
                },
                ///////////////
                /// Send data to dataLayer
                ///////////////
                sendDataLayer(formName: string, step?: number | string | null, tag?: string) {
                    const actionName = 'productCheckout'
                    const categoryName = 'tunnel'

                    // Datalayer for appointment form
                    if (formName == FormName.FORM_APPOINTMENT) {
                        const choicesArray: Array<object> = []
                        let obj = {}
                        if (this.stepNumber == 4) {
                            this.arrayChoice['projectTypes'].forEach((value) => {
                                obj = {
                                    id: value,
                                    category: value,
                                    name: value,
                                }
                                choicesArray.push(obj)
                            });
                            sendTunnelForm(
                                { slot1: "rdv", slot2: "etape" + step, slot3: tag ? tag : 'localisation' },
                                { categoryName: categoryName },
                                { actionName: actionName },
                                { choicesArray }
                            )
                            window.sessionStorage.setItem("productPurchase", JSON.stringify(choicesArray));
                        } else {
                            sendTunnelForm(
                                { slot1: "rdv", slot2: "etape" + step, slot3: tag ? tag : 'localisation' },
                                { categoryName: categoryName },
                                { actionName: actionName }
                            )
                        }
                    }

                    // Datalayer for quotation form
                    if (formName == FormName.FORM_QUOTATION) {
                        if (this.stepNumber == 0 || this.stepNumber > 1) {
                            sendTunnelForm(
                                { slot1: "devis", slot2: "etape" + step, slot3: tag ? tag : 'choix-produit' },
                                { categoryName: categoryName },
                                { actionName: actionName },
                            )
                        } else {
                            sendTunnelForm(
                                { slot1: "devis", slot2: "etape" + step, slot3: tag ? tag : 'choix-produit' },
                                { categoryName: categoryName },
                                { actionName: actionName },
                                {
                                    id: this.arrayChoice['product-type'],
                                    category: this.arrayChoice['product-type'],
                                    name: this.arrayChoice['product-type']
                                }
                            )
                            window.sessionStorage.setItem("productPurchase", JSON.stringify(this.arrayChoice['product-type']));
                        }
                    }
                },
                sendEventPrevious(formName: string, step?: number | string | null) {
                    if (formName == FormName.FORM_APPOINTMENT) {
                        sendEventDataLayer('click', 'tunnel-rdv', 'etape-precedente', step)

                    }
                    if (formName == FormName.FORM_QUOTATION) {
                        sendEventDataLayer('click', 'tunnel-devis', 'etape-precedente', step)
                    }
                },
                sendEventStep(formName: string, step: any, choices: any) {
                    if (formName == FormName.FORM_APPOINTMENT) {
                        if (choices.name) {
                            sendEventDataLayer('click', 'tunnel-rdv', step.name, choices.name)
                        } else {
                            sendEventDataLayer('click', 'tunnel-rdv', step.name, choices[0])
                        }
                    }

                    if (formName == FormName.FORM_QUOTATION) {
                        if (choices.name) {
                            sendEventDataLayer('click', 'tunnel-devis', step.name, choices.name)
                        } else {
                            sendEventDataLayer('click', 'tunnel-devis', step.name, choices)
                        }
                    }
                },
                autocompleteFromFieldName: autocompleteFromFieldName,
            },
        };
    });
});
